var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-506 -290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511 326.5 549 326.5 549 328.5 511 328.5Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 330.5 551 330.5 551 332.5 509 332.5Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 309 519 308 513 308 513 309 514.5 310 514.006 322.829 513 323.5 513 324.5 519 324.5 519 323.5 517.994 322.829 517.5 310 519 309Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 309 526 308 520 308 520 309 521.5 310 521.006 322.829 520 323.5 520 324.5 526 324.5 526 323.5 524.994 322.829 524.5 310 526 309Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533 309 533 308 527 308 527 309 528.5 310 528.006 322.829 527 323.5 527 324.5 533 324.5 533 323.5 531.994 322.829 531.5 310 533 309Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 309 540 308 534 308 534 309 535.5 310 535.006 322.829 534 323.5 534 324.5 540 324.5 540 323.5 538.994 322.829 538.5 310 540 309Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 309 547 308 541 308 541 309 542.5 310 542.006 322.829 541 323.5 541 324.5 547 324.5 547 323.5 545.994 322.829 545.5 310 547 309Z",
    fill: "#D3BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.5 306 547.5 306 547.5 304 548.577 304 548.577 302.673 530 295 511.423 302.673 511.423 304 512.5 304 512.5 306Z",
    fill: "#D3BA68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture2);
export default __webpack_public_path__ + "static/media/Picture2.1423fc439739c42628f39b645ed759fe.svg";
export { ForwardRef as ReactComponent };